module.exports = __webpack_public_path__ + "img/header-bg.eb4926cf.png";